// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5484":"cc00fa56","7444":"64327546"}[chunkId] + ".chunk.css";
};